import React, { useEffect, useState } from 'react';
import { difference, filter, isEqual, without, differenceBy } from 'lodash';
import Card from '../shared/cards/Card';
import LoaderContainer from '../shared/loaderContainer/LoaderContainer';
import DynamicFormFieldRenderer from '../Reusable/DynamicFormFieldRenderer';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { HTTP_STATUS } from '../../http/constants/http.status';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

import { getLoggedInOrg } from '../../util/admin-utils';

import { clipboard, clipboardCheck } from '../../assets/components/svgs';
import { DualingListPick } from '../shared/DualingList/DualingList';
import { init } from 'i18next';
import { getUserByID } from '../../http/user-management-services';
import { getOrganizations, getChildOrganizations } from '../../http/organization-services';
import { AppConstants } from '../../constants/AppConstants';
import { getUserLoggedInOrg } from '../../util/OrganizationUtil';

const Container = styled.div`
  width: 100%;
  background-color: #f5f5f5;
  min-height: 25vh;
  max-height: 75vh;
  overflow: auto;
`;

interface ManageUserEnrollmentProps {
  userId: string;
  setEnrolledOrgList: Function;
  setUpdateEnrollForOrg: Function;
  loggedInOrgId: string;
}

const ManageUserEnrollment: React.FC<ManageUserEnrollmentProps> = ({
  userId,
  setEnrolledOrgList,
  setUpdateEnrollForOrg,
  loggedInOrgId
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [availableOrg, setAvailableOrg] = useState<any>([]);
  const [enrolledOrg, setEnrolledOrg] = useState<any>([]);
  const userProfileInfo: any = useAppSelector((state) => state.userManagement.userProfileInfo);
  const [orgMap, setOrgMap] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    setIsLoading(true);
    const init = async () => {
      let userDetails, orgResponse, loggedInOrgResponse;
      if (AppConstants.ENROLL_ORG_CHILD_ONLY) {
        [userDetails, orgResponse, loggedInOrgResponse] = await Promise.all([
          getUserByID(userId),
          getChildOrganizations(
            loggedInOrgId,
            AppConstants.QUERY_PARAM_LEVEL_DESENDANTS,
            '',
            AppConstants.DEFAULT_PAGE,
            AppConstants.MAXIMUM_PAGE_SIZE,
            [`name,asc`]
          ),
          getUserLoggedInOrg(userProfileInfo)
        ]);
      } else {
        [userDetails, orgResponse] = await Promise.all([
          getUserByID(userId),
          getOrganizations(
            '',
            AppConstants.DEFAULT_PAGE,
            AppConstants.MAXIMUM_PAGE_SIZE,
            `${AppConstants.QUERY_PARAM_NAME},${AppConstants.DEFAULT_SORT_ASC}`
          )
        ]);
      }

      let { status: orgStatus, data: orgResponseData } = orgResponse;
      const { status: userDetailsStatus, data: userDetailsData } = userDetails;
      if (orgStatus == HTTP_STATUS.HTTP_OK && userDetailsStatus === HTTP_STATUS.HTTP_OK) {
        if (AppConstants.ENROLL_ORG_CHILD_ONLY) {
          if (orgResponseData && orgResponseData.data) {
            orgResponseData.data = [...orgResponseData.data, loggedInOrgResponse];
            orgResponseData.data = orgResponseData.data.sort((a: any, b: any) =>
              a.name.localeCompare(b.name)
            );
          }
        }
        setOrgDataForEnroll(orgResponseData, userDetailsData);
      }
      setIsLoading(false);
    };
    init();
  }, []);

  const createOrgHashMap = (orgresponse: any) => {
    let orgHashMap: any = {};
    orgresponse.forEach((org: any) => {
      const { id } = org;
      orgHashMap[id] = { ...org };
    });
    setOrgMap(orgHashMap);
    return orgHashMap;
  };

  const setOrgEnrolledData = (enrolledOrgList: any, orgHashMap: any) => {
    const enrolledOrgData: any = [];

    enrolledOrgList.forEach((org: any) => {
      const { isOwner, organizationId } = org;
      // if (!isOwner && orgHashMap[organizationId]) {
      //   enrolledOrgData.push({
      //     ...orgHashMap[organizationId]
      //   });
      // }
      if (orgHashMap[organizationId]) {
        enrolledOrgData.push({
          ...orgHashMap[organizationId],
          isEleDisabled: isOwner
        });
      }
    });
    setEnrolledOrg(enrolledOrgData);
    return enrolledOrgData;
  };

  const filterParentOrgData = (orgData: any) => {
    const { organizationId } = getLoggedInOrg(userProfileInfo);
    return orgData.filter((org: any) => org.id !== organizationId);
  };

  const setOrgDataForEnroll = (orgResponse: any, userDetails: any) => {
    const { data: orgData } = orgResponse;
    //const filteredOrgData = filterParentOrgData(orgData);
    const filteredOrgData = orgData;
    const orgHashMap = createOrgHashMap(filteredOrgData);
    const { organization } = userDetails;
    const enrolledOrg = setOrgEnrolledData(organization, orgHashMap);
    const availableOrgList = differenceBy(filteredOrgData, enrolledOrg, 'name');
    setAvailableOrg(availableOrgList);
    setEnrolledOrgList(enrolledOrg);
  };

  return (
    <LoaderContainer isLoading={isLoading}>
      <div className="flex w-full flex-col  overflow-visible px-2 py-3">
        <div className="flex">
          <DualingListPick
            initialData={availableOrg}
            setInitialData={setAvailableOrg}
            outputData={enrolledOrg}
            setOutputData={(data: any) => {
              setUpdateEnrollForOrg([...data]);
              setEnrolledOrg([...data]);
            }}
            searchPlaceholder={t('T_SEARCH_ORG_NAME')}
            fieldKey="name"
            fieldValues={['name']}
            inputHeader={t('T_AVAILABLE_ORGANIZATION')}
            outputHeader={t('T_ENROLLED_ORGANIZATION')}
            orderingControls={false}
            disabled={false}
            styles={{
              listWidth: 'w-[48%]',
              listHeight: 'h-[30rem]',
              buttonHeight: 'h-8',
              buttonWidth: 'w-8'
            }}
          ></DualingListPick>
        </div>
      </div>
    </LoaderContainer>
  );
};

export default ManageUserEnrollment;
